import { useHistory } from "react-router-dom";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Container from "@mui/material/Container";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";

export default function NoPermissionsMessage() {
    const history = useHistory();

    return (
        <Box
            component="main"
            sx={{
                minHeight: "calc(100vh - 64px)",
                px: 2,
                py: { xs: 5, sm: 8 },
                display: "grid",
                placeItems: "center",
                backgroundColor: "background.default",
            }}
        >
            <Container maxWidth="sm" disableGutters>
                <Card
                    variant="outlined"
                    role="status"
                    aria-labelledby="access-restricted-title"
                    sx={{
                        overflow: "hidden",
                        borderRadius: 3,
                        borderColor: "divider",
                        boxShadow: (theme) =>
                            theme.palette.mode === "dark"
                                ? "0 10px 34px rgba(0, 0, 0, 0.32)"
                                : "0 10px 34px rgba(20, 35, 25, 0.08)",
                    }}
                >
                    <CardContent
                        sx={{
                            p: { xs: 3, sm: 4 },
                            textAlign: "center",
                            "&:last-child": {
                                pb: { xs: 3, sm: 4 },
                            },
                        }}
                    >
                        <Box
                            sx={{
                                width: 64,
                                height: 64,
                                mx: "auto",
                                mb: 2.25,
                                borderRadius: "50%",
                                display: "grid",
                                placeItems: "center",
                                color: "primary.main",
                                backgroundColor: "rgba(0, 149, 61, 0.09)",
                                border: "1px solid rgba(0, 149, 61, 0.14)",
                            }}
                        >
                            <LockOutlinedIcon sx={{ fontSize: 31 }} />
                        </Box>

                        <Typography
                            id="access-restricted-title"
                            variant="h4"
                            component="h1"
                            sx={{
                                fontSize: { xs: 25, sm: 30 },
                                lineHeight: 1.2,
                            }}
                        >
                            Access restricted
                        </Typography>
                        <Typography
                            variant="body1"
                            sx={{
                                mt: 1.25,
                                color: "text.secondary",
                                lineHeight: 1.65,
                            }}
                        >
                            Your account does not currently have permission to
                            view this page.
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{ mt: 1, color: "text.secondary" }}
                        >
                            If you think this is a mistake, contact a Nodiant
                            administrator.
                        </Typography>

                        <Divider sx={{ my: 3 }} />

                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                flexWrap: "wrap",
                                gap: 1,
                            }}
                        >
                            <Button
                                color="inherit"
                                variant="outlined"
                                startIcon={<ArrowBackIcon />}
                                onClick={() => history.goBack()}
                            >
                                Go back
                            </Button>
                            <Button
                                variant="contained"
                                disableElevation
                                startIcon={<HomeOutlinedIcon />}
                                onClick={() => history.push("/")}
                            >
                                Return home
                            </Button>
                        </Box>
                    </CardContent>
                </Card>
            </Container>
        </Box>
    );
}
